
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/dashboard-logo.png';
import {ReactComponent as LogoutIcon} from './svgs/logouticon.svg';

import DropdownLayout from '../components/Dropdown';

const SidebarLink = ({ to, icon, text, isActive }) => {
  const [active, setActive] = useState(isActive);

  return (
    <Link
      to={to}
      className={`sidebar-link ${active ? 'active' : ''} flex gap-6`}
      onClick={() => setActive(true)}
    >
      <span className={`sidebar-icon ${active ? 'active' : ''}`}>{icon}</span>
      <span className="sidebar-text">{text}</span>
    </Link>
  );
};

const ActiveSidebarLink = ({ to, icon, text }) => {
    return (
      <Link to={to} className="sidebar-link active flex gap-6">
        <span className="sidebar-icon active">{icon}</span>
        <span className="sidebar-text">{text}</span>
      </Link>
    );
  };


  const SideBar = ({ links }) => {

    return (
      <aside className="sidebar">
        <section className="sidebar-item">
          <DropdownLayout userInitials={'RG'} userName={'Rachel Green'} role={'Attendant'} dropdownLabel={'Manager'}/>
          <section className='sidebar-menu mt-16'>
            <ul>
              {links.map((link, index) => (
                <li key={index}>
                  {link.isActive ? (
                    <ActiveSidebarLink {...link} />
                  ) : (
                    <SidebarLink {...link} />
                  )}
                </li>
              ))}
              <div className='flex flex-col gap-10 logout-section'>
              <Link to={'/'} className='flex gap-6'>
                <LogoutIcon/>
                <p className='sidebar-text'>Logout</p>
              </Link>
              <Link to={'/login'}>
                <img src={logo} alt="laundry Squared Logo" className='site-logo'/>
              </Link>
              </div>
            </ul>
          </section>
        </section>
      </aside>
    );
  };
  
  export default SideBar;